import { merge, evolve } from "ramda";

// Create a new StyledMapType object, passing it the array of styles,
// as well as the name to be displayed on the map type control.
const formatStyle = styles =>
  new google.maps.StyledMapType(JSON.parse(styles), { name: "Styled Map" });

function GoogleMaps({ style, zoom, maxZoom, minZoom }) {
  const defaults = {
    zoom,
    maxZoom,
    minZoom
  };

  return {
    create: createMap(formatStyle(style), defaults)
  };
}

function createMap(styles, defaults) {
  const withDefaults = merge(defaults);

  return ({ center }, element) => {
    const canvas = document.createElement("div");
    const options = withDefaults({
      center: new google.maps.LatLng(center[1], center[0]),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: false,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.LARGE,
        position: google.maps.ControlPosition.LEFT_CENTER
      },
      mapTypeControl: false
    });

    canvas.classList.add("google-map");

    element.appendChild(canvas);

    let markers = {};
    let map = new google.maps.Map(canvas, options);

    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set("map_style", styles);
    map.setMapTypeId("map_style");

    return {
      addMarker: addMarker(map, markers)
    };
  };
}

function addMarker(map, markers) {
  return ({
    id,
    name,
    latitude,
    longitude,
    slug,
    anchor,
    size = [14, 14],
    popup = true,
    image
  }) => {
    var coordinates = [
      parseFloatToFixed(7, latitude),
      parseFloatToFixed(7, longitude)
    ];
    var offset = anchor || [size[0] / -2, size[1] / -2];

    var image = new google.maps.MarkerImage(
      image,
      // The marker dimensions
      new google.maps.Size(...size),
      // The origin for this image is 0, 0.
      new google.maps.Point(0, 0),
      // The anchor for this image
      new google.maps.Point(...offset),
      // The scaled size
      new google.maps.Size(...size)
    );

    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(...coordinates),
      map: map,
      title: name,
      icon: image
    });

    markers[id] = marker;

    return marker;
  };
}

function parseFloatToFixed(positions, floatish) {
  return +parseFloat(floatish).toFixed(positions);
}

export default GoogleMaps;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/topo/google_maps.js